import { useInjection } from 'inversify-react';
import { uniqBy } from 'lodash';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { ReactElement, useContext } from 'react';
import { IUserStore } from '../../user/user.store';
import { IAnnotationsStore } from '../annotations.store';
import { ViewAttributesDropdown } from '../components/ViewAttributesDropdown';
import { isAttributeQuestion } from '../question.model';
import { ImageSegmentations } from '../submodules/segmentations/segmentationContextMenu/imageSegmentations.context';

export const ViewAttributesContainer = observer((): ReactElement => {
  const userStore = useInjection(IUserStore.$);
  const annotationsStore = useInjection(IAnnotationsStore.$);
  const imageSegmentationsContext = useContext(ImageSegmentations);

  const handleSelectedAttrutesChanged = (selected: string[]): void => {
    userStore.setSelectedAttributesPerProject(annotationsStore.projectId, selected);
  };

  const handleAttributesNamesVisibilityChanged = (value: boolean): void => {
    userStore.setAttributesNamesVisibility(annotationsStore.projectId, value);
  };

  const attributes = Object.entries(imageSegmentationsContext.segmentations)
    .filter(([k, v]) => imageSegmentationsContext.selectedProjects.includes(k) && v.length > 0)
    .map(([k, v]) => [
      imageSegmentationsContext.projects.find((p) => p.id === k)?.name,
      uniqBy(
        v.flatMap((s) => s.questions.map((q) => ({ text: q.text, id: q.id, projectId: k }))),
        (x) => x.id
      ),
    ]);

  attributes.unshift([
    imageSegmentationsContext.projects.find((p) => p.id === annotationsStore.projectId)?.name,
    annotationsStore.questions.filter((x) => isAttributeQuestion(x)).map((q) => ({ text: q.text, id: q.id, projectId: annotationsStore.projectId })),
  ]);

  return (
    <ViewAttributesDropdown
      selectedAttributes={userStore.selectedAttributesPerProject.get(annotationsStore.projectId) ?? []}
      attributes={toJS(Object.fromEntries(attributes))}
      showAttributesNames={userStore.attributesNamesVisibilityPerProject.get(annotationsStore.projectId) ?? true}
      selectedAttrutesChanged={handleSelectedAttrutesChanged}
      showAttributesNamesChanged={handleAttributesNamesVisibilityChanged}
    />
  );
});
